const BoxOpacity = (props: any) => {
  let visible = ((props.visible && props.visible == true) ? true : false);
  return (
    ((!visible) ?
      <div className={`BoxOpacity`}>
        {props.children}
      </div>
      :
      <></>
    )
  )
}

export default BoxOpacity